import { useContext, useEffect } from "react";

import { useDialog } from "@datanac/datanac-mui-toolkit";
import { Grid } from "@mui/material";
import { AppContext } from "App";
import WorkspaceHeader from "components/Workspaces/WorkspaceHeader";

import { TilleyLogoIcon } from "../Icons/Icons";

export default function EmptyWorkspace() {
  const { globalState } = useContext(AppContext);

  const { component: confirmDialogComponent } = useDialog();

  const loadData = async () => {
    // const budgets = await selectBudgets();
    // budgetActions.replace(budgets);
  };

  useEffect(() => {
    loadData();
  }, [globalState?.producer_token]);

  return (
    <>
      <WorkspaceHeader
        title="Tilley. How farms grow money"
        category={{ title: "Tilley", icon: <TilleyLogoIcon sx={{ width: "24px", height: "24px" }} /> }}
      />

      <Grid container spacing={2}></Grid>

      {confirmDialogComponent}
    </>
  );
}
